import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ProductMockup } from "./ProductMockup";
export function Hero() {
  return <section className="hero" id="top" data-id="element-48" data-mp="9ktdnmoh20x8">
      <div className="shell" data-id="element-49" data-mp="9luzmm7107tq">
        <header className="brand-row" data-id="element-50" data-mp="9l37jlcn0s87">
          <a href="#top" aria-label="Team Communication Ready home" data-id="element-51" data-mp="4m8nkg2xoxmi">
            TEAM COMMUNICATION <span data-id="element-52" data-mp="1297bo2fk8x8s">READY</span>
          </a>
          <a href="#offer-details" className="header-preview" data-id="element-53" data-mp="12861e06dces4">
            See the offer <ArrowRightIcon size={15} aria-hidden="true" data-id="element-54" data-mp="xa4gd9pdu5e0" />
          </a>
        </header>
        <div className="hero-grid" data-id="element-55" data-mp="sarv2te5t6dj">
          <div className="hero-copy" data-id="element-56" data-mp="s9q7jpfyirex">
            <p className="eyebrow" data-id="element-57" data-mp="nc88cqrqrqk4">FOR TEAM LEADERS & INTERNAL FACILITATORS</p>
            <h1 data-id="element-58" data-mp="neaw145f97lo">
              Your next team communication workshops.
              <br data-id="element-59" data-mp="3d2bkprwf73wl" />
              <span data-id="element-60" data-mp="3d2tqbf4z2uh6">Already planned for you.</span>
            </h1>
          </div>
          <figure className="hero-visual" data-id="element-61" data-mp="381nwfdzkt162">
            <ProductMockup priority data-id="element-62" data-mp="3j8ixl0k6uiv8" />
            <figcaption className="sr-only" data-id="element-63" data-mp="3j9kalakrlffl">
              Complete digital PDF kit with 5 workshops and 5 bonuses. Devices shown for illustration.
            </figcaption>
          </figure>
          <div className="hero-action" data-id="element-64" data-mp="39b4ib4a0404i">
            <CtaButton href="#offer-details" data-id="element-65" data-mp="39a378zszjdms">
              See my complete training plan <ArrowRightIcon size={19} aria-hidden="true" data-id="element-66" data-mp="3e84nze2xv0v3" />
            </CtaButton>
            <p className="cta-note" data-id="element-67" data-mp="30hrjxmt646b1">$27 USD · One-time payment · Complete guide · 5 workshops + 5 bonuses</p>
          </div>
          <p className="hero-lead" data-id="element-68" data-mp="35aaueawk6lbm">
            Minute-by-minute agendas, facilitator scripts, workplace role-play cases and feedback sheets.
            Choose a session, review the plan and print the materials.
          </p>
        </div>
      </div>
    </section>;
}